import { render, staticRenderFns } from "./TrackCovers.vue?vue&type=template&id=687010ea&"
import script from "./TrackCovers.vue?vue&type=script&lang=js&"
export * from "./TrackCovers.vue?vue&type=script&lang=js&"
import style0 from "./TrackCovers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports